import type { WebhooksUpdateContent } from './Definitions/Types';
import type { WebhooksDataAPI } from './Definitions/WebhookTypes';

export const webhooksTransformer = (response: WebhooksDataAPI): WebhooksUpdateContent[] => {
  return response.data.map((webhooks) => ({
    id: webhooks.id,
    name: webhooks.name,
    url: webhooks.url,
    eventTypes: webhooks.event_types,
    secretKey: webhooks.secret_key,
    customHeaders: webhooks.custom_headers,
    createdAt: webhooks.created_at,
    updatedAt: webhooks.updated_at,
  }));
};

export const translateEventName = (eventName: string): string => {
  switch (eventName) {
    case 'geofence_in':
      return 'Entrada em local de interesse';
      break;

    case 'geofence_out':
      return 'Saída de local de interesse';
      break;

    default:
      return '';
      break;
  }
};

export const translateErrorMessage = (errorMessage: string): string => {
  if (errorMessage.indexOf('500') > -1) {
    return 'A requisição falhou com o código 500. Verifique a consistência dos dados passados e da URL ou tente novamente mais tarde';
  }

  if (errorMessage.indexOf('503') > -1) {
    return 'A requisição falhou com o código 503. O serviço está temporariamente indisponível, tente novamente mais tarde';
  }

  if (errorMessage.indexOf('504') > -1) {
    return 'A requisição falhou com o código 504. A requisição se extendeu além do esperado, tente novamente';
  }

  if (errorMessage.indexOf('400') > -1) {
    return 'A requisição falhou com o código 400. Verifique seus cabeçalhos e certifique que a requisição não demande um corpo para ser executada';
  }

  if (errorMessage.indexOf('403') > -1) {
    return 'A requisição falhou com o código 403. Certifique-se que seus cabeçalhos de autenticação e/ou autorização estão corretamente preenchidos';
  }

  return errorMessage;
};
